export default {
  rooms: [],
  floors: []
};